import * as React from 'react';

export interface IButtonsPrimaryProps {
}

interface IState {
}

/**
 * Primary button group to use within Buttons component. Rendered in prime position.
 */
class ButtonsPrimary extends React.PureComponent<IButtonsPrimaryProps, IState> {
    static displayName: string = 'ButtonsPrimary';

    render () {
        if (React.Children.count(this.props.children) === 0) {
            return null;
        } else {
            return this.props.children;
        }
    }
}

export default ButtonsPrimary;
